import type { Variants } from "framer-motion";

/**
 * Section-switch reveal used by SettingsPage. Kept short and low-key
 * (Stripe/Linear tempo, not a marketing-page entrance) — a small y-offset
 * fade that respects MotionConfig's reducedMotion="user" set at the page root.
 */
export const sectionVariants: Variants = {
  hidden: { opacity: 0, y: 8 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.2, ease: "easeOut" },
  },
  exit: {
    opacity: 0,
    y: -8,
    transition: { duration: 0.15, ease: "easeOut" },
  },
};
